import "./DashboardOffers.css";

const DashboardOffers = () => {
  return (
    <div className="dashboardOffers flex-row">
      <h1>Switch to Pro Plan today and save up to 30%</h1>
      <button
        className="btn primary"
        onClick={() =>
          (window.location.href =
            "https://geniusparkle.com/pricing.html?upgrade")
        }
      >
        Upgrade my plan
      </button>
    </div>
  );
};

export default DashboardOffers;
